// 图表相关配置
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import tool from '../../utils/tool';

const lineColorMap = {
  'fund-point': '#FE6933',
  'index-point': '#479DFF',
  'type-point': '#999999',
  'bench-point': '#FF9900',
  'net-value-rate': '#479DFF',
  'history-net-value': '#FE6933',
};

export default {
  // 接口的点数据列表key，与图例展示顺序一致
  pointKeyList: {
    accProfit: ['pointList', 'benchPointList', 'indexPointList', 'typePointList'],
    perNetValue: ['netValueList', 'valueRiseList'],
    accNetValue: ['historyValueList'],
    trendOfGold: ['pointList', 'risePointList'],
    profitOf10000: ['netValueList', 'historyValueList'],
    annualizationOf7D: ['historyValueList', 'valueRateList'],
  },
  // 图例配置
  legendConfig: {
    // 累计收益
    accProfit: [{
      type: 'fund-point',
      iconType: 'dot', // dot | line
      color: '#ff4400',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: 'periodText', // 标签名key, 为空时取label
      label: '近一年',
    }, {
      type: 'type-point',
      iconType: 'dot', // dot | line
      color: '#999999',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '同类平均',
      iconUrl: 'https://img.1234567.com.cn/trade/2018102616580210.png',
    }, {
      type: 'index-point',
      iconType: 'dot', // dot | line
      color: '#008AFF',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: 'indexName', // 标签名key, 为空时取label
      label: '沪深300',
      iconUrl: 'https://j5.dfcfw.com/WG/conf/20210419/d76b5662a99644b380dcfad42aa1763e.png',
    }, {
      type: 'bench-point',
      iconType: 'dot', // dot | line
      color: '#FF9900',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '业绩比较基准',
      iconUrl: 'https://img.1234567.com.cn/trade/2018102616580210.png',
    }],
    // 单位净值
    perNetValue: [{
      type: 'per-net-value',
      iconType: 'dot', // dot | line
      color: '#ff4400',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '',
      labelKey: '', // 标签名key, 为空时取label
      label: '单位净值',
      valueFormatter: (value) => parseFloat(value)?.toFixed(4),
    }, {
      type: 'net-value-rise',
      iconType: '', // dot | line
      color: '',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '日涨幅',
    }],
    // 累计净值
    accNetValue: [{
      type: 'history-net-value',
      iconType: 'dot', // dot | line
      color: '#ff4400',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '',
      labelKey: '', // 标签名key, 为空时取label
      label: '累计净值',
      valueFormatter: (value) => parseFloat(value)?.toFixed(4),
    }],
    // 金价走势
    trendOfGold: [{
      type: 'gold-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '元/克',
      labelKey: '', // 标签名key, 为空时取label
      label: '国内AU9999',
    }, {
      type: 'gold-rise-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '日涨幅',
    }],
    // 货币基金-万元收益
    profitOf10000: [{
      type: 'per-net-value',
      iconType: '', // dot | line
      color: '#ff4400',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '',
      labelKey: '', // 标签名key, 为空时取label
      label: '万元收益',
      valueFormatter: (value) => parseFloat(value)?.toFixed(4),
    }, {
      type: 'history-net-value',
      iconType: '', // dot | line
      color: '',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '7日年化',
      valueFormatter: (value) => parseFloat(value)?.toFixed(4),
    }],
    // 货币基金-7日年化
    annualizationOf7D: [{
      type: 'history-net-value',
      iconType: 'dot', // dot | line
      color: '#ff4400',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '7日年化',
      valueFormatter: (value) => parseFloat(value)?.toFixed(4),
    }, {
      type: 'net-value-rate',
      iconType: 'dot', // dot | line
      color: '#008AFF',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '一年定存',
      valueFormatter: (value) => parseFloat(value)?.toFixed(2),
    }],
    // 分时图
    timeSharing: [{
      type: 'price-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '',
      labelKey: '', // 标签名key, 为空时取label
      label: '价格',
      valueFormatter: (value) => parseFloat(value)?.toFixed(3) || '--',
    }, {
      type: 'volume-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '',
      labelKey: '', // 标签名key, 为空时取label
      label: '成交量',
      valueFormatter: (value) => tool.formateBigNumber(value, 2),
    }, {
      type: 'rise-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '涨跌幅',
      valueFormatter: (value) => (parseFloat(value) * 100).toFixed(2) || '--',
    }],
    // k线图
    kLine: [{
      type: 'price-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '',
      labelKey: '', // 标签名key, 为空时取label
      label: '价格',
      valueFormatter: (value) => parseFloat(value)?.toFixed(3) || '--',
    }, {
      type: 'volume-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: false, // 是否需要涨红跌绿
      valueSymbol: '',
      labelKey: '', // 标签名key, 为空时取label
      label: '成交量',
      valueFormatter: (value) => tool.formateBigNumber(value, 2),
    }, {
      type: 'rise-point',
      iconType: '', // dot | line
      color: '',
      isRateValue: true, // 是否需要涨红跌绿
      valueSymbol: '%',
      labelKey: '', // 标签名key, 为空时取label
      label: '涨跌幅',
      valueFormatter: (value) => (isEmpty(value) ? '--'
        : value),
    }],
  },
  lineChartConfig: { // 李冉新折线图配置
    accProfit: { // 累计收益
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => `${numeral(value).format('0.00')}%`,
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', (type) => (type === 'fund-point' ? 2 : 1)],
          color: ['type', (type) => (lineColorMap[type] || '#ffffff')],
        },
        area: {
          color: ['type', (type) => (type === 'fund-point' ? 'l(90) 0:#FF7C4C 1:#FEFFFF' : 'transparent')],
        },
      },
      tooltip: {
        main: ['type', 'fund-point'],
      },
    },
    perNetValue: { // 单位净值
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => (isEmpty(value) ? '--' : value?.toFixed(4)), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', [2]],
          color: ['type', ['#FE6933']],
        },
        area: {
          color: ['type', ['l(90) 0:#FF7C4C 1:#FEFFFF']],
        },
      },
      tooltip: {
        main: ['type', 'per-net-value'],
      },
    },
    accNetValue: { // 累计净值
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => (isEmpty(value) ? '--' : value?.toFixed(4)), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', [2]],
          color: ['type', ['#FE6933']],
        },
        area: {
          color: ['type', ['l(90) 0:#FF7C4C 1:#FEFFFF']],
        },
      },
      tooltip: {
        main: ['type', 'history-net-value'],
      },
    },
    trendOfGold: { // 黄金
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => (value?.toFixed(2)), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', [2]],
          color: ['type', ['#FE6933']],
        },
        area: {
          color: ['type', ['l(90) 0:#FF7C4C 1:#FEFFFF']],
        },
      },
      tooltip: {
        main: ['type', 'gold-point'],
      },
    },
    profitOf10000: { // 货币基金-万元收益
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => (value?.toFixed(4)), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', [2]],
          color: ['type', ['#FE6933']],
        },
        area: {
          color: ['type', ['l(90) 0:#FF7C4C 1:#FEFFFF']],
        },
      },
      tooltip: {
        main: ['type', 'per-net-value'],
      },
    },
    annualizationOf7D: { // 货币基金-7日年化
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => (value?.toFixed(4)), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', (type) => (type === 'history-net-value' ? 2 : 1)],
          color: ['type', (type) => (lineColorMap[type] || '#ffffff')],
        },
        area: {
          color: ['type', (type) => (type === 'history-net-value' ? 'l(90) 0:#FF7C4C 1:#FEFFFF' : 'transparent')],
        },
      },
      tooltip: {
        main: ['type', 'history-net-value'],
      },
    },
  },
  // 图表配置
  chartConfig: {
    accProfit: { // 累计收益
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => `${numeral(value).format('0.00')}%`, // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'index-point', // 指数
          size: 1, // 线宽
          color: '#479DFF', // 颜色
          shape: 'line', // 线条样式
        },
        {
          type: 'type-point', // 同类平均
          size: 1,
          color: '#999999',
          shape: 'line',
        },
        {
          type: 'bench-point', // 业绩比较基准
          size: 1,
          color: '#FF9900',
          shape: 'line',
        },
        {
          type: 'fund-point', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
          showMin: true,
          showMax: true,
          formatter: (value) => (`${value.toFixed(2) || '--'}%`),
        },
      ],
      throttleTime: 200, // 节流时间
    },
    perNetValue: { // 单位净值
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => (value?.toFixed(4)), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'per-net-value', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
          showMax: true,
          showMin: true,
          formatter: (value) => (`${value.toFixed(4) || '--'}%`),
        },
      ],
      throttleTime: 200, // 节流时间
    },
    accNetValue: { // 累计净值
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => (value?.toFixed(4)), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'history-net-value', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
        },
      ],
      throttleTime: 200, // 节流时间
    },
    trendOfGold: { // 金价走势
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => (value?.toFixed(2)), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'gold-point', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
        },
      ],
      throttleTime: 200, // 节流时间
    },
    profitOf10000: { // 货币基金-万元收益
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => (value?.toFixed(4)), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'per-net-value', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
        },
      ],
      throttleTime: 200, // 节流时间
    },
    annualizationOf7D: { // 货币基金-7日年化
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => (value?.toFixed(4)), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'history-net-value', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
        },
      ],
      throttleTime: 200, // 节流时间
    },
  },
  // 指数弹窗默认配置
  indexPopupList: [
    { indexName: '上证指数', indexCode: '000001', color: '#000000' },
    { indexName: '深证指数', indexCode: '399001', color: '#000000' },
    { indexName: '创业板指', indexCode: '399006', color: '#000000' },
    { indexName: '沪深300', indexCode: '000300', color: '#000000' },
    { indexName: '中小100', indexCode: '399005', color: '#000000' },
    { indexName: '中证500', indexCode: '000905', color: '#000000' },
    { indexName: '上证50', indexCode: '000016', color: '#000000' },
    { indexName: '偏股基金指数', indexCode: '930950', color: '#000000' },
  ],
  chartFlagMap: new Map([
    [ // 分红
      'dividend',
      {
        text: '分红',
        color: '#E48B17',
        flagColor: '#F59C26',
        lineColor: '#F59C26',
      },
    ],
    [ // 基金经理变更
      'managerChange',
      {
        text: '经理变更',
        color: '#E48B17',
        flagColor: '#F59C26',
        lineColor: '#F59C26',
      },
    ],
    [ // 巨额赎回
      'largeRedemption',
      {
        text: '巨额赎回',
        color: '#E48B17',
        flagColor: '#F59C26',
        lineColor: '#F59C26',
      },
    ],
  ]),
  chartPointMap: {
    dividend: '#F59C26',
    managerChange: '#F59C26',
    largeRedemption: '#F59C26',
  },

};
